import { render, staticRenderFns } from "./NewStorage.vue?vue&type=template&id=49b88781"
import script from "./NewStorage.vue?vue&type=script&lang=js"
export * from "./NewStorage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports